const DEFAULT_LOCALE_FORMAT = {
  calendar: {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'ddd., MMM. D',
    sameElse: 'ddd., MMM. D',
  },
};
const momentLocaleFormats = {
  en: DEFAULT_LOCALE_FORMAT,
  fr: {
    calendar: {
      sameDay: '[Aujourd’hui]',
      nextDay: '[Demain]',
      nextWeek: 'ddd D MMM',
      sameElse: 'ddd D MMM',
    },
  },
  es: {
    calendar: {
      sameDay: '[hoy]',
      nextDay: '[mañana]',
      nextWeek: 'ddd, D MMM',
      sameElse: 'ddd, D MMM',
    },
  },
  ja: {
    calendar: {
      sameDay: '[同日]',
      nextDay: '[翌日]',
      nextWeek: 'ddd, D MMM',
      sameElse: 'ddd, D MMM',
    },
  },
  ca: {
    calendar: {
      sameDay: '[avui]',
      nextDay: '[demà]',
      nextWeek: 'ddd D MMM',
      sameElse: 'ddd D MMM',
    },
  },
  nl: {
    calendar: {
      sameDay: '[Vandaag]',
      nextDay: '[Morgen]',
      nextWeek: 'ddd D MMM',
      sameElse: 'ddd D MMM',
    },
  },
  pt: {
    calendar: {
      sameDay: '[Hoje]',
      nextDay: '[Amanhã]',
      nextWeek: 'ddd D MMM',
      sameElse: 'ddd D MMM',
    },
  },
  de: {
    calendar: {
      sameDay: '[Heute]',
      nextDay: '[Morgen]',
      nextWeek: 'ddd D MMM',
      sameElse: 'ddd D MMM',
    },
  },
};

export { DEFAULT_LOCALE_FORMAT };
export default momentLocaleFormats;
